import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { Button, Card, Row, Col, Form, OverlayTrigger, Tooltip, Spinner, Modal } from "react-bootstrap";
import supplierService from "../../services/master/SupplierService.js";
import { FaEdit, FaSync, FaSearch } from "react-icons/fa";
import ModalPnbpV2 from "../penugasan/modals/ModalPnbpV2.js";
import SweetAlert from "react-bootstrap-sweetalert";

const EditPnbp = () => {
  const NIP = localStorage.getItem("username") || "";
  const KODE_UPT = localStorage.getItem("kdUnit") || "";

  // State Data & Pagination
  const [pnbpList, setPnbpList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  // State Baris Data yang Sedang Diedit
  const [selectedRow, setSelectedRow] = useState(null);

  // State Modal Edit PNBP
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nomor_aju: "",
    kode_tarif: "",
    nm_tarif: "",
    tarif: 0,
    volume: "",
    satuan: "",
    pembagi: "",
    total_tarif: 0,
    updatedby: NIP,
  });

  // State Modal Pilih Tarif (ModalPnbpV2)
  const [showPnbpTarif, setShowPnbpTarif] = useState(false);

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    message: "",
    type: "info",
    showCancel: false,
    confirmBtnText: "OK",
    cancelBtnText: "Batal",
    confirmBtnBsStyle: "primary",
    cancelBtnBsStyle: "secondary",
    onConfirm: () => {},
    onCancel: () => {},
  });

  const hideAlert = () => {
    setAlertConfig((prev) => ({ ...prev, show: false }));
  };

  const showAlert = (title, message, type = "info", options = {}) => {
    setAlertConfig({
      show: true,
      title,
      message,
      type,
      showCancel: options.showCancel || false,
      confirmBtnText: options.confirmBtnText || "OK",
      cancelBtnText: options.cancelBtnText || "Batal",
      confirmBtnBsStyle: options.confirmBtnBsStyle || "primary",
      cancelBtnBsStyle: options.cancelBtnBsStyle || "secondary",
      onConfirm: () => {
        if (options.onConfirm) options.onConfirm();
        else hideAlert();
      },
      onCancel: () => {
        if (options.onCancel) options.onCancel();
        else hideAlert();
      },
    });
  };

  // 1. Fetch Data PNBP
 const fetchPnbpData = useCallback(async (page = currentPage, limit = perPage, keyword = searchKeyword) => {
  setLoading(true);

  try {
    const trimmedKeyword = keyword ? keyword.trim() : "";

    if (trimmedKeyword) {
      const response = await supplierService.getPnbpByNomorAju(trimmedKeyword);
      const result = response?.data;

      let dataArray = [];
      if (Array.isArray(result?.data)) {
        dataArray = result.data;
      } else if (Array.isArray(result)) {
        dataArray = result;
      } else if (result?.data) {
        dataArray = [result.data];
      } else if (result) {
        dataArray = [result];
      }

      if (dataArray.length === 0) {
        showAlert("Informasi", `Data dengan Nomor Aju "${trimmedKeyword}" tidak ditemukan.`, "info");
      }

      setPnbpList(dataArray);
      setTotalRows(result?.pagination?.total_items ?? result?.total ?? dataArray.length);
    } else {
      const response = await supplierService.getPnbpNull(KODE_UPT, page, limit, "");
      const result = response?.data;

      setPnbpList(result?.data || []);
      setTotalRows(result?.pagination?.total_items ?? result?.total ?? 0);
    }
  } catch (error) {
    console.error("Gagal mengambil data PNBP:", error);
    showAlert("Error", "Gagal mengambil data PNBP: " + (error.response?.data?.message || error.message), "error");
    setPnbpList([]);
    setTotalRows(0);
  } finally {
    setLoading(false);
  }
}, [currentPage, perPage, searchKeyword, KODE_UPT]);

  useEffect(() => {
    fetchPnbpData(currentPage, perPage, searchKeyword);
  }, [currentPage, perPage, fetchPnbpData]);

  // 2. Event Handler Pagination & Search
  const handlePageChange = (page) => setCurrentPage(page);

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchKeyword.trim()) {
      showAlert("Peringatan", "Masukkan Nomor Aju terlebih dahulu!", "warning");
      return;
    }
    setCurrentPage(1);
    fetchPnbpData(1, perPage, searchKeyword);
  };

  const handleReset = () => {
    setSearchKeyword("");
    setCurrentPage(1);
    fetchPnbpData(1, perPage, "");
  };

  // 3. Handler Edit & Tarif Selection
  const handleEdit = (row) => {
    const dtl = row.tr_dtl_pnbp || {};
    const vol = dtl.volume ?? "";
    const rate = dtl.tarif || dtl.mst_tarif?.tarif || 0;

    setSelectedRow(row);

    setFormData({
      nomor_aju: row.nomor_aju || "",
      kode_tarif: dtl.kodeTarif || dtl.kode_tarif || "",
      nm_tarif: dtl.nmTarif || dtl.nm_tarif || dtl.mst_tarif?.nmTarif || "",
      tarif: rate,
      volume: vol,
      satuan: dtl.satuan || "",
      pembagi: dtl.pembagi ?? "",
      total_tarif: dtl.totalTarif || (vol ? parseFloat(vol) * rate : 0),
      updatedby: NIP,
    });
    setShowModal(true);
  };

  const handleClickPnbpTarif = () => {
    setShowPnbpTarif(true);
  };

  const handleClickPilih = (dataclick) => {
    const vol = parseFloat(formData.volume) || 0;
    const rate = parseFloat(dataclick.tarif) || 0;

    setFormData((prev) => ({
      ...prev,
      kode_tarif: dataclick.kdTarif || dataclick.kodeTarif,
      nm_tarif: dataclick.nmTarif,
      tarif: rate,
      satuan: dataclick.satuan || prev.satuan,
      pembagi: dataclick.pembagi ?? prev.pembagi,
      total_tarif: vol * rate,
    }));
    setShowPnbpTarif(false);

    showAlert("Tarif Terpilih", `Anda memilih tarif: ${dataclick.nmTarif}`, "success");
  };

  const handleVolumeChange = (e) => {
    const val = e.target.value;
    const volNum = parseFloat(val) || 0;
    const rateNum = parseFloat(formData.tarif) || 0;

    setFormData((prev) => ({
      ...prev,
      volume: val,
      total_tarif: volNum * rateNum,
    }));
  };

  // 4. Submit Update PNBP
  const executeSubmitUpdate = async () => {
    hideAlert();
    setSubmitting(true);

    const payload = {
      kode_tarif: formData.kode_tarif,
      volume: parseFloat(formData.volume),
      satuan: formData.satuan,
      pembagi: formData.pembagi ? parseInt(formData.pembagi) : null,
      total_tarif: parseFloat(formData.total_tarif),
      updatedby: formData.updatedby,
    };

    try {
      await supplierService.updatePnbpByNomorAju(formData.nomor_aju, payload);
      setShowModal(false);
      showAlert("Berhasil!", `Data PNBP ${formData.nomor_aju} berhasil diperbarui!`, "success");
      fetchPnbpData(currentPage, perPage, searchKeyword);
    } catch (error) {
      console.error("Gagal update PNBP:", error);
      showAlert("Gagal!", "Gagal mengupdate data: " + (error.response?.data?.message || error.message), "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmitUpdate = (e) => {
    e.preventDefault();

    if (!formData.kode_tarif) {
      showAlert("Peringatan", "Silakan pilih Tarif PNBP terlebih dahulu!", "warning");
      return;
    }

    // if (!formData.volume || parseFloat(formData.volume) <= 0) {
    //   showAlert("Peringatan", "Volume harus diisi dengan angka lebih dari 0!", "warning");
    //   return;
    // }

    showAlert(
      "Konfirmasi Perubahan",
      `Apakah Anda yakin ingin mengupdate data PNBP untuk Nomor Aju ${formData.nomor_aju}?`,
      "warning",
      {
        showCancel: true,
        confirmBtnText: "Ya, Simpan",
        cancelBtnText: "Batal",
        confirmBtnBsStyle: "primary",
        cancelBtnBsStyle: "secondary",
        onConfirm: executeSubmitUpdate,
      }
    );
  };

  const columnsPnbp = [
    {
      name: "No",
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "90px",
    },
    {
      name: "Nama UPI",
      selector: (row) => row.tr_ppk?.NAMA_TRADER || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Nomor Aju",
      selector: (row) => row.nomor_aju || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: "Volume",
      selector: (row) => row.tr_dtl_pnbp?.volume ?? "-",
      width: "100px",
    },
    {
      name: "Satuan",
      selector: (row) => row.tr_dtl_pnbp?.satuan || "-",
      width: "120px",
    },
    {
      name: "Jumlah Tarif",
      selector: (row) => row.tr_dtl_pnbp?.total_tarif || "-",
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.sts_pembayaran || "Belum Bayar",
      wrap: true,
    },
    {
      name: "Action",
      width: "90px",
      cell: (row) => (
        <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit PNBP</Tooltip>}>
          <Button
            size="sm"
            variant="warning"
            className="text-white"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(row);
            }}
          >
            <FaEdit />
          </Button>
        </OverlayTrigger>
      ),
    },
  ];

  return (
    <Row className="g-3">
      <Col sm="12">
        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center bg-white">
            <h5 className="card-title mb-0">Pencarian Data PNBP</h5>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSearchSubmit}>
              <Row className="align-items-end">
                <Col sm="4">
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Masukkan Nomor Aju..."
                      value={searchKeyword}
                      onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col sm="2">
                  <Button variant="primary" type="submit" className="w-100 me-2">
                    Cari
                  </Button>
                </Col>
                <Col sm="2">
                  <Button variant="secondary" className="w-100" onClick={handleReset}>
                    Reset
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        <Card className="shadow-sm mt-3">
          <Card.Header className="bg-white">
            <h5 className="card-title mb-0">Edit PNBP</h5>
          </Card.Header>
          <Card.Body>
            <DataTable
              columns={columnsPnbp}
              data={pnbpList}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              progressPending={loading}
              progressComponent={
                <div className="text-center my-3">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 mb-0">Loading data PNBP...</p>
                </div>
              }
              noDataComponent="Tidak ada data PNBP"
              customStyles={{
                headCells: {
                  style: {
                    backgroundColor: "#00acee",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                },
                cells: {
                  style: {
                    fontSize: "13px",
                  },
                },
              }}
            />
          </Card.Body>
        </Card>
      </Col>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit PNBP ({formData.nomor_aju})</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmitUpdate}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nama Tarif <span className="text-danger">*</span></Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="text"
                  value={formData.nm_tarif}
                  placeholder="Pilih Tarif PNBP..."
                  disabled
                />
                <Button variant="primary" onClick={handleClickPnbpTarif} className="text-nowrap">
                  <FaSearch className="me-1" /> Pilih Tarif
                </Button>
              </div>
            </Form.Group>

            <Row>
              <Col sm="6">
                <Form.Group className="mb-3">
                  <Form.Label>Tarif PNBP</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.tarif ? `Rp ${formData.tarif.toLocaleString("id-ID")}` : "0"}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col sm="6">
                <Form.Group className="mb-3">
                  <Form.Label>Satuan</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.satuan}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm="6">
                <Form.Group className="mb-3">
                  <Form.Label>Volume <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="number"
                    step="any"
                    required
                    value={formData.volume}
                    onChange={handleVolumeChange}
                    placeholder="Masukkan volume"
                  />
                </Form.Group>
              </Col>
              <Col sm="6">
                <Form.Group className="mb-3">
                  <Form.Label>Total Tarif</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.total_tarif ? `Rp ${formData.total_tarif.toLocaleString("id-ID")}` : "0"}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm="6">
                <Form.Group className="mb-3">
                  <Form.Label>Di ubah oleh :</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.updatedby}
                    readOnly
                    className="bg-light"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Batal
            </Button>
            <Button variant="primary" type="submit" disabled={submitting}>
              {submitting ? <Spinner animation="border" size="sm" /> : "Simpan Perubahan"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {showPnbpTarif && (
        <ModalPnbpV2
          showAddPnbp={showPnbpTarif}
          handleClosePnbp={() => setShowPnbpTarif(false)}
          handleClickPilih={handleClickPilih}
          idDisposisi={selectedRow?.id_disposisi || selectedRow?.idDisposisi || ""}
          sts_pembayaran={selectedRow?.sts_pembayaran || "Belum Bayar"}
          dataDisposisi={{
            idDisposisi: selectedRow?.id_disposisi || selectedRow?.idDisposisi || "",
            ...selectedRow,
          }}
          datappm={{
            nomorAju: formData.nomor_aju || selectedRow?.nomor_aju || "",
            kdUpt: KODE_UPT || selectedRow?.kd_upt || "",
            ...selectedRow,
          }}
        />
      )}

      {alertConfig.show && (
        <SweetAlert
          title={alertConfig.title}
          onConfirm={alertConfig.onConfirm}
          onCancel={alertConfig.onCancel}
          showCancel={alertConfig.showCancel}
          confirmBtnText={alertConfig.confirmBtnText}
          cancelBtnText={alertConfig.cancelBtnText}
          confirmBtnBsStyle={alertConfig.confirmBtnBsStyle}
          cancelBtnBsStyle={alertConfig.cancelBtnBsStyle}
          success={alertConfig.type === "success"}
          error={alertConfig.type === "error"}
          warning={alertConfig.type === "warning"}
          info={alertConfig.type === "info"}
        >
          {alertConfig.message}
        </SweetAlert>
      )}
    </Row>
  );
};

export default EditPnbp;